module.exports = __webpack_public_path__ + "img/tertiary_2x2.0b57f72f.svg";